<template>
    <b-table
        id="indices"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive
        :busy="configTable.load"
        show-empty
        hover
        bordered
        class="mb-0"
        head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhum índice encontrado.</p>
        </template>
        <template v-slot:head(0)="{ item }">
            Data Evento <i class="filter" :class="!isEmpty(filtro.dataEvento) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Evento', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(0)="{ item }">
            <p class="text-center">
                {{ item.dataEvento }}
            </p>
        </template>
        <template v-slot:head(1)="{ item }">
            Data Fim <i class="filter" :class="!isEmpty(filtro.dataFim) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data Fim', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            <p class="text-center">
                {{ item.dataFim }}
            </p>
        </template>
        <template v-slot:head(2)="{ item }">
            Código <i class="filter" :class="!isEmpty(filtro.codigo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Código', 'mascara', '', '#########', $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            <p class="text-right">
                {{ item.codEvento }}
            </p>
        </template>
        <template v-slot:head(3)="{ item }">
            Descrição <i class="filter" :class="!isEmpty(filtro.descricao) || filtro.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Descrição', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            {{ item.evento }}
        </template>
        <template v-slot:head(4)="{ item }">
            Moeda <i class="filter" :class="!isEmpty(filtro.moeda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Moeda', 'mascara', '', '#########', $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            <p class="text-right">
                {{ item.moeda }}
            </p>
        </template>
        <template v-slot:head(5)="{ item }">
            Valor <i class="filter" :class="!isEmpty(filtro.valor) || filtro.filtrarValor == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Valor', 'numerico', '', null, $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            <p class="text-right">
                {{ item.valor }}
            </p>
        </template>
        <template v-slot:head(6)="{ item }">
            Complemento <i class="filter" :class="!isEmpty(filtro.complemento) || filtro.filtrarDescricao == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Complemento', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.texto }}
        </template>
    </b-table>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../mixins/formatarMixins';

export default {
    props: ['resultado', 'fields', 'configTable', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.$emit('consultar');
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        }
    }
}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
